import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-100 bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          {/* Logo & Beskrivelse */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 group">
              <img 
                src="https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/303407055-562303575688039-5873020734054747914-n.png" 
                alt="Nygaards Vinduespolering" 
                className="h-20 sm:h-24 w-auto object-contain transition-transform group-hover:scale-105 bg-white rounded-none p-1.5"
              />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Professionel vinduespolering og tagrenderensning i Kerteminde og omegn. Vi leverer skinnende rene ruder og personlig service til både private og erhverv.
            </p>
            <div className="mt-4 text-xs text-slate-500">
              CVR: <span className="font-mono">40339604</span>
            </div>
          </div>

          {/* Hurtige links */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Hurtige links
            </h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Ydelser */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Vores ydelser
            </h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/ydelser/erhvervs-vinduespolering" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Erhvervs Vinduespolering
                </Link>
              </li>
              <li>
                <Link to="/ydelser/privat-vinduespolering" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Privat Vinduespolering
                </Link>
              </li>
              <li>
                <Link to="/ydelser/tagrende-rens" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Tagrende rens
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Se alle ydelser
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontaktoplysninger */}
          <div>
            <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              Kontakt os
            </h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot mt-1 text-brand-orange" />
                <span className="text-sm text-slate-400">
                  Nygaards Vinduespolering<br />
                  Tværgyden 151<br />
                  5300 Kerteminde
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-brand-orange" />
                <a href="tel:27501226" className="text-sm text-slate-400 hover:text-white transition-colors whitespace-nowrap">
                  27 50 12 26
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-brand-orange" />
                <a href="mailto:nygaardspolering@gmail.com" className="text-sm text-slate-400 hover:text-white transition-colors break-all sm:break-normal">
                  nygaardspolering@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-8 border-slate-800" />

        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-xs text-slate-500">
            &copy; {currentYear} Nygaards Vinduespolering. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </footer>
  );
}
